import {EditOutlined, SettingOutlined} from '@ant-design/icons'
import {AdUnitBean} from 'common/api/api.ts'
import {GoToReportButton} from 'common/components/GoToReportButton.tsx'
import {CommonRoutes} from 'common/context/commonRoutes'
import React from 'react'
import {useNavigate} from 'react-router-dom'
import { ListActionButton } from 'common/components/ListActionButton.tsx'

interface Props {
    record: AdUnitBean
    generateCode: () => void
}

export const AdUnitActionBar: React.FC<Props> = ({record, generateCode}) => {
    const navigateTo = useNavigate()

    return (
        <div style={{display: 'flex', gap: 8, justifyContent: 'center'}}>
            <ListActionButton
              htmlType="button"
              onClick={() => generateCode()}
              tooltip='Generate Script'
            >
                <SettingOutlined/>
            </ListActionButton>
            <GoToReportButton title="Report Builder" filterName="AdUnitId" id={record.id}/>
            <ListActionButton
              htmlType="button"
              onClick={() => navigateTo(`${CommonRoutes.AD_UNIT}/${record.id}/edit`)}
              tooltip='Edit'
            >
                <EditOutlined/>
            </ListActionButton>
        </div>
    )
}